import React, { useEffect } from 'react';

const MoeVideo = ({placements, isFull, isDesktop, closeSecOffset = 10}) => {
  if (!placements) {
    return null;
  }
  const placement = isFull ? (isDesktop ? placements.fullPc : placements.fullMob) : (isDesktop ? placements.prevPc : placements.prevMob);

    if (!placement) {
        return null;
    }
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn1.moe.video/p/cr.js";
    script.onload = () => {
      if (window.addContentRoll) {
        const config = {
          width: '100%',
          placement: placement,
          promo: true,
          advertCount: 50,
          slot: 'sticky',
          sound: 'onclick',
          deviceMode: 'all',
          background: 'none',
          fly: {
            mode: 'stick',
            width: 445,
            closeSecOffset: closeSecOffset,
            position: 'bottom-right',
            indent: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            positionMobile: 'bottom',
          },
          style: { fly: { zindex: 100} },
        };
        window.addContentRoll(config);
      }
    };
    document.body.appendChild(script);
  }, []);

  return null;
};

export default MoeVideo; 